import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import { DispatchProp } from "react-redux";

type HandlerType = Handler<{ reset: boolean },DispatchProp<any>>;

export const DispatchResetMultipleSaleQuantity: HandlerType = props => {
    props.dispatch({
        type: "Components/ProductDetails/ResetMultipleSaleQuantity",
        reset: props.parameter.reset
    });
};

export const chain = [DispatchResetMultipleSaleQuantity];
const resetMultipleSaleQuantity = createHandlerChainRunner(chain, "ResetMultipleSaleQuantity");
export default resetMultipleSaleQuantity;
